import React from 'react';

/**
 * WhatsApp Web style vertical resize handle divider bar.
 * Allows click-and-drag or touch-and-drag to resize split screen panels.
 */
const ResizeHandle = ({ onMouseDown, isDragging, className = '' }) => {
  return (
    <div
      onMouseDown={onMouseDown}
      onTouchStart={onMouseDown}
      className={`relative w-[6px] hover:w-[6px] h-full cursor-col-resize select-none z-30 group transition-colors flex-shrink-0 ${
        isDragging ? 'bg-emerald-500/80 shadow-md' : 'bg-transparent hover:bg-emerald-500/50'
      } ${className}`}
      title="Drag left or right to resize sidebar"
      data-testid="resize-handle"
    >
      {/* Visual indicator line */}
      <div
        className={`absolute inset-y-0 left-1/2 -translate-x-1/2 w-[2px] transition-colors ${
          isDragging ? 'bg-emerald-500' : 'bg-wa-border group-hover:bg-emerald-500'
        }`}
      />
      
      {/* Central handle grip pill on hover/drag */}
      <div
        className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1.5 h-8 rounded-full transition-opacity duration-150 ${
          isDragging ? 'bg-emerald-600 opacity-100' : 'bg-emerald-500 opacity-0 group-hover:opacity-100'
        }`}
      />
    </div>
  );
};

export default ResizeHandle;
